export default __webpack_public_path__ + "static/char-55-anr-af626c66b5a890b496703f8712bd51f3.gif";